// extracted by mini-css-extract-plugin
export default {"container":"loginPage_container__uwMc6","details":"loginPage_details__jgtYm","register":"loginPage_register__csAH-"};